export default __webpack_public_path__ + "static/media/P303 zu P305.58519170.mp3";